import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromReducer from './unenrolled-device.reducer';
import { UnenrolledDeviceState } from './unenrolled-device.state';

export const selectUnenrolledDeviceState = createFeatureSelector<UnenrolledDeviceState>('unenrolled-device');

export const selectDeviceIds = createSelector(selectUnenrolledDeviceState, fromReducer.selectUnenrolledDeviceIds);

export const selectUnenrolledDeviceEntities = createSelector(
  selectUnenrolledDeviceState,
  fromReducer.selectUnenrolledDeviceEntities
);

export const selectAllDevices = createSelector(selectUnenrolledDeviceState, fromReducer.selectAllUnenrolledDevices);
